import React, { useEffect } from 'react';
import "./notifications.scss";
import useNotifications from './useNotifications';
import NotificationList from './NotificationList';

const NotificationsPage = () => {
  const {
    notifications,
    notificationCounts,
    params,
    loading,
    expandedNotificationIndex,
    parsedNotificationsArr,
    notificationListRef,
    notificationTypes,
    markRead,
    setMarkRead,
    handleParamsChange,
    handleExpandClick,
    closeMenu,
    onOpen,
    getNotificationGroup,
    t
  } = useNotifications();

  useEffect(() => {
    onOpen();
    return () => {
      closeMenu();
    };
  }, []);

  return (
    <div className='notifications-page'>
      <div className='notifications-page__header'>
        <h2>{t("navbar.notifications", "Notifications")}</h2>
        <div className="d-flex align-items-center gap-3 justify-content-center">
          <div className="custom-control custom-switch d-flex align-items-center">
            <input
              checked={params.read === "false"}
              onChange={(e) => handleParamsChange("read", e.target.checked ? "false" : null)}
              type="checkbox"
              id="show_only_unread_page"
              name="show_only_unread_page"
              className="custom-control-input"
            />
            <label className="custom-control-label unread-text" htmlFor="show_only_unread_page">
              {t("navbar.showOnlyUnread", "Show only unread")}
            </label>
          </div>
        </div>
      </div>
      <NotificationList
        notifications={notifications}
        notificationCounts={notificationCounts}
        params={params}
        loading={loading}
        expandedNotificationIndex={expandedNotificationIndex}
        parsedNotificationsArr={parsedNotificationsArr}
        notificationListRef={notificationListRef}
        notificationTypes={notificationTypes}
        markRead={markRead}
        setMarkRead={setMarkRead}
        handleParamsChange={handleParamsChange}
        handleExpandClick={handleExpandClick}
        getNotificationGroup={getNotificationGroup}
        isFullPage={true}
        t={t}
      />
    </div>
  );
};

export default NotificationsPage;
